// extracted by mini-css-extract-plugin
export default {"carsBookmark":"carsBookmark_carsBookmark__yloHl"};